// « La semaine du club » (D-121, accueil du bureau, maquette a7) : logique pure, testée (club-week.test.ts).
import { addDays, parseLocalDate } from './schedule';

/** Les jours du week-end qui vient : samedi et dimanche ; le samedi même, samedi et dimanche ; le dimanche, ce dimanche. */
export function weekendOf(today: string): string[] {
  const dow = parseLocalDate(today).getDay();   // 0 dimanche … 6 samedi
  if (dow === 0) return [today];
  const sat = addDays(today, 6 - dow);
  return [sat, addDays(sat, 1)];
}

/** « Ce week-end : 2 matchs, dont 1 à domicile. » */
export function weekendLine(n: number, home: number): string {
  if (n === 1) return home ? 'Ce week-end : 1 match, à domicile.' : 'Ce week-end : 1 match, à l’extérieur.';
  if (!home) return `Ce week-end : ${n} matchs, à l’extérieur.`;
  if (home === n) return `Ce week-end : ${n} matchs, à domicile.`;
  return `Ce week-end : ${n} matchs, dont ${home} à domicile.`;
}

/** Une équipe juste en nombre pour un match : moins de 5 attendus (« short »), 5 ou 6 (« tight »), sinon « ok ». */
export function squadMargin(present: number): 'short' | 'tight' | 'ok' {
  if (present < 5) return 'short';
  return present <= 6 ? 'tight' : 'ok';
}
